import { render, staticRenderFns } from "./JgpRadio.vue?vue&type=template&id=1a123be7&"
import script from "./JgpRadio.vue?vue&type=script&lang=js&"
export * from "./JgpRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports